import ENV from '../../utils/env';

const FIRST_BIND_WECHAT = `${ENV}/v1/basic.account.account_web.AccountWeb/BindWeixinCallback`; // 首次绑定微信
const VALIDATE_WECHAT = `${ENV}/v1/basic.account.account_web.AccountWeb/VerifyWeixinCallback`; // 验证微信
// const VALIDATE_WECHAT = `https://gateway.qidian.qq.com/v1/basic.account.account_web.AccountWeb/VerifyWeixinCallback`; // 本地调试临时用这个 微信登录有域名限制
const BIND_WECHAT = `${ENV}/v1/basic.account.account_web.AccountWeb/OwnerWeixinCallback`; // 绑定微信
export default {
    FIRST_BIND_WECHAT,
    VALIDATE_WECHAT,
    BIND_WECHAT,
};
